// Ported from the Polaris kit: src/components/ui/button/index.js.
// Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
// Change the design in the kit first, then re-port.
import { cva } from 'class-variance-authority';

export { default as Button } from './Button.vue';

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-polaris-md type-polaris-body font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-polaris-ring focus-visible:ring-polaris-ring/50 focus-visible:ring-[3px] aria-invalid:ring-polaris-destructive/20 dark:aria-invalid:ring-polaris-destructive/40 aria-invalid:border-polaris-destructive",
  {
    variants: {
      variant: {
        default:
          'bg-polaris-primary text-polaris-primary-foreground hover:bg-polaris-primary/90',
        destructive:
          'bg-polaris-destructive text-polaris-destructive-foreground hover:bg-polaris-destructive/90 focus-visible:ring-polaris-destructive/20 dark:focus-visible:ring-polaris-destructive/40',
        outline:
          'border border-solid border-polaris-border bg-polaris-background shadow hover:bg-polaris-accent hover:text-polaris-accent-foreground dark:bg-polaris-input/30 dark:border-polaris-input dark:hover:bg-polaris-input/50',
        secondary:
          'bg-polaris-secondary text-polaris-secondary-foreground hover:bg-polaris-secondary/80',
        ghost:
          'hover:bg-polaris-accent hover:text-polaris-accent-foreground dark:hover:bg-polaris-accent/50',
        // Polaris patch: a link is underlined ink in both themes. Upstream uses text-polaris-primary with the underline on
        // hover only: no affordance in light (primary is ink) and solar text in dark (solar is reserved).
        link: 'text-polaris-foreground underline underline-offset-4 decoration-polaris-foreground/40 hover:decoration-polaris-foreground',
      },
      size: {
        default: 'h-9 px-4 py-2 has-[>svg]:px-3',
        xs: "h-6 gap-1 rounded-polaris-md px-2 type-polaris-caption has-[>svg]:px-1.5 [&_svg:not([class*='size-'])]:size-3",
        sm: 'h-8 rounded-polaris-md gap-1.5 px-3 has-[>svg]:px-2.5',
        lg: 'h-10 rounded-polaris-md px-6 has-[>svg]:px-4',
        icon: 'size-9 p-0',
        'icon-xs':
          "size-6 rounded-polaris-md [&_svg:not([class*='size-'])]:size-3 p-0",
        'icon-sm': 'size-8 p-0',
        'icon-lg': 'size-10 p-0',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
);
